import { deleteRequest, getRequest, postRequest, putRequest } from 'config/Axios/baseConfig';
import {
  DrugReferenceByConceptCodePayload,
  DrugReferenceByConceptCodeResponse,
  DrugReferenceByConceptCodeSingleResponse
} from 'Interfaces/ReferenceInterfaces/DrugReferenceByConceptCodeInterface';

export const drugReferenceByConceptCodeServices = {
  getAllDrugReferenceByConceptCodes: (
    page = 1,
    pageSize = 10000,
    search?: string
  ): Promise<DrugReferenceByConceptCodeResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        let url = `pps/drug-reference-concept-codes?page=${page}&page_size=${pageSize}`;
        if (search) {
          url += `&search=${encodeURIComponent(search)}`;
        }

        const { data } = await getRequest<DrugReferenceByConceptCodeResponse>(url);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getDrugReferenceByConceptCodeById: (
    id: number
  ): Promise<DrugReferenceByConceptCodeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<DrugReferenceByConceptCodeSingleResponse>(
          `pps/drug-reference-concept-codes/${id}`
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  createDrugReferenceByConceptCode: (
    drugReferenceData: DrugReferenceByConceptCodePayload
  ): Promise<DrugReferenceByConceptCodeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<DrugReferenceByConceptCodeSingleResponse>(
          'pps/drug-reference-concept-codes/',
          drugReferenceData
        );
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  },

  updateDrugReferenceByConceptCode: (
    id: number,
    drugReferenceData: DrugReferenceByConceptCodePayload
  ): Promise<DrugReferenceByConceptCodeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await putRequest<DrugReferenceByConceptCodeSingleResponse>(
          `pps/drug-reference-concept-codes/${id}/`,
          drugReferenceData
        );
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  },

  deleteDrugReferenceByConceptCode: (id: number): Promise<any> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await deleteRequest(`pps/drug-reference-concept-codes/${id}`);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }
};
